import { callPlanet } from './'

export const fetchContext = (partner, locale) => (
  callPlanet(`Context/${partner}/${locale}`)
)
